import { useAdDetails } from './useAdDetails';
import { AdDetails } from '@/api/types/ads.types';

export function useIsShop(initialAdDetails?: AdDetails | null) {
  const { adDetails } = useAdDetails();
  const { shop } = adDetails ?? initialAdDetails ?? {};

  return !!shop;
}
